// ----------------------
// Order Enums
// ----------------------
export enum DiscountApplyTypeEnum {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}

/** Operational state: OPEN = in progress, READY = ready for pickup/service, CLOSED = completed, VOIDED = invalidated */
export enum OrderStatusEnum {
  OPEN = "OPEN",
  READY = "READY",
  CLOSED = "CLOSED",
  VOIDED = "VOIDED",
}

/** Must match GraphQL / backend `OrderVoidReasonCode` (same as eatsbitsdesktop). */
export enum OrderVoidReasonCode {
  CUSTOMER_REQUESTED_CANCEL = "CUSTOMER_REQUESTED_CANCEL",
  CUSTOMER_LEFT = "CUSTOMER_LEFT",
  WRONG_ITEM_ENTERED = "WRONG_ITEM_ENTERED",
  WRONG_ORDER_CREATED = "WRONG_ORDER_CREATED",
  DUPLICATE_ORDER = "DUPLICATE_ORDER",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  ITEM_UNAVAILABLE = "ITEM_UNAVAILABLE",
  KITCHEN_ERROR = "KITCHEN_ERROR",
  TEST_ORDER = "TEST_ORDER",
  SYSTEM_ERROR = "SYSTEM_ERROR",
  OTHER = "OTHER",
}


export enum DiscountTypeEnum {
  EVENT = "EVENT",
  COUPON = "COUPON",
  LOYALTY = "LOYALTY",
  STAFF = "STAFF",
}

export enum OrderTypeEnum {
  PICK_UP = "PICK_UP",
  DELIVERY = "DELIVERY",
  DINE_IN = "DINE_IN",
  ENTERPRISE = "ENTERPRISE",
}

export enum OrderSourceEnum {
  CUSTOMER_WEB_APP = "CUSTOMER_WEB_APP",
  RESTAURANT_WEB_APP = "RESTAURANT_WEB_APP",
  RESTAURANT_DESKTOP_APP = "RESTAURANT_DESKTOP_APP",
  ENTERPRISE_WEB_APP = "ENTERPRISE_WEB_APP",
}

export enum PaymentMethodTypeEnum {
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  GIFT_CARD = "GIFT_CARD",
  OTHER = "OTHER",
}

/** Payment lifecycle: in-progress (PENDING, AUTHORIZED, SETTLED), success (CAPTURED, PAID), failed/reversed (FAILED, VOIDED, REFUNDED) */
export enum PaymentStatusEnum {
  PENDING = "PENDING",
  AUTHORIZED = "AUTHORIZED",
  SETTLED = "SETTLED",
  CAPTURED = "CAPTURED",
  PAID = "PAID",
  FAILED = "FAILED",
  VOIDED = "VOIDED",
  REFUNDED = "REFUNDED",
}

export enum PaymentTypeEnum {
  CASH = "CASH",
  CARD = "CARD",
}

/** Card flow: AUTH = authorize then capture later; SALE = single-step capture */
export enum PaymentModeEnum {
  AUTH = "AUTH",
  SALE = "SALE",
}

export enum ReceiptTypeEnum {
  KITCHEN = "KITCHEN",
  RESTAURANT = "RESTAURANT",
  CUSTOMER = "CUSTOMER",
}

export enum OrderSplitTypeEnum {
  EVEN = "EVEN",
  ITEM = "ITEM"
}

// for frontend only

export enum OrderActionType {
  PAY_BILLS = "PAY_BILLS",
  SEE_DETAILS = "SEE_DETAILS",
}

export enum OrderListNavigationDirectionEnum {
  INCREMENT = "INCREMENT",
  DECREMENT = "DECREMENT",
}
